// Dev-only logger — silenced in production builds. Use everywhere instead of raw console.
const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';

export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  log: (...args) => { if (isDev) console.log(...args); }
};

export default logger;
